import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './components/app/app.component';
import {LoginComponent} from './components/login/login.component';
import {AppRoutingModule} from './app.router';
import {FormsModule} from '@angular/forms';
import {Ng2Webstorage} from 'ng2-webstorage';
import {ToastrModule} from 'ngx-toastr';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {RootComponent} from './components/root/root.component';
import {HttpClientModule} from '@angular/common/http';
import {BaseService} from './services/base.service';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ProjectService} from './services/project.service';
import {AgGridModule} from 'ag-grid-angular/main';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {ProjectWizardComponent} from './components/project-wizard/project-wizard.component';
import {NgxTimelineModule} from 'ngx-timeline/src/ngx-timeline/ngx-timeline.module';
import {AmexioDashboardModule} from 'amexio-ng-extensions/dashboard';
import {AmexioWidgetModule} from 'amexio-ng-extensions';
import {PrinceStageService} from './services/prince.service';
import {CategoryService} from './services/category.service';
import {QuestionService} from './services/question.service';
import {ResponseService} from './services/response.service';
import {FilterByPrinceIdPipe} from './pipes/filterByPrinceId/filter-by-prince-id.pipe';
import {TabsModule} from 'ngx-tabs';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {StatusService} from './services/status.service';
import { FilterByCategoryIdPipe } from './pipes/filterByCategoryId/filter-by-category-id.pipe';
import {AuthService} from './services/auth.service';
import {CookieService} from 'ngx-cookie-service';
import {ResponseOptionService} from './services/responseOption.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    RootComponent,
    PageNotFoundComponent,
    ProjectWizardComponent,
    FilterByPrinceIdPipe,
    FilterByCategoryIdPipe
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    Ng2Webstorage,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      closeButton: true,
      progressBar: true,
      timeOut: 0,
      extendedTimeOut: 0
    }),
    AgGridModule.withComponents([]),
    NgxTimelineModule,
    AmexioDashboardModule,
    AmexioWidgetModule,
    TabsModule,
    NgbModule.forRoot()
  ],
  providers: [
    BaseService,
    ProjectService,
    PrinceStageService,
    CategoryService,
    QuestionService,
    ResponseService,
    StatusService,
    ResponseOptionService,
    AuthService,
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/app.module.ts